export const pageNames: Record<string, string> = {
  dashboard: 'Dashboard',
  articles: 'Article Management',
  brands: 'Brand Management',
  suppliers: 'Supplier Management',
  users: 'User Management',
  analytics: 'Analytics',
  settings: 'Settings',
  profile: 'Profile',
};
